import httpManager from "@/app/shared/utils/httpManager";
import {
  ReportTypes,
  PayPromiseReportTypes,
  PayPromiseReportTypesNames,
} from "@/app/reports/utils/enums";

export async function downloadRanking({ filters } = {}) {
  let query = "";
  if (filters.entity) query += `entity=${filters.entity}&`;
  query += `portfolio=${filters.portfolio}&`;
  if (filters.base) query += `base=${filters.base}&`;
  query += `type_ranking=${filters.type}&`;
  query += `start_date=${filters.startDate}&`;
  query += `end_date=${filters.endDate}`;

  const pdp_type = PayPromiseReportTypesNames[PayPromiseReportTypes.Ranking];

  const url = `/reports/${ReportTypes.PayPromise}/download/?pdp_type=${pdp_type}&${query}`;

  const response = await httpManager.post(url, {}, { blob: true });
  return response;
}
